import { InjectionToken } from '@angular/core';
import { ValidateCargoService } from '../../types/control';

export const VALIDATION_PROVIDER = new InjectionToken<ValidateCargoService>(
  'ValidationProvider',
);
